import React from 'react';
import { bool, func, instanceOf } from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router';
import Checkbox from '@material-ui/core/Checkbox';
import { APP_ROOT_URL } from '../../actions/urlTypes';
import {
  setAddNewFlag,
  getDetailByContractId,
  setSupportNav,
} from '../../actions/contractAdminActions';
import { useDispatch } from '../../components/common/react-redux-hooks';
import { CA_ADD_CONTRACT_STATUS_OPTIONS } from '../../constants';
import { getSelectedStatus } from '../../util/ContractAdminUtils';
import IconCheckBoxEmpty from '../../components/autocode/ACShared/IconCheckBoxEmpty';
import IconCheckBoxCheck from '../../components/autocode/ACShared/IconCheckBoxCheck';

const CATableRowItems = ({
  data = null,
  handleOnChange,
  selectAllClicked,
  isAllChecked,
  unableCheckBox = false,
}) => {
  const dispatch = useDispatch();
  const setFlag = value => {
    dispatch(setAddNewFlag(value));
    dispatch(setSupportNav('Contract', 'Details'));
    dispatch(getDetailByContractId(data.contractId));
  };

  const { contractName, account, contractStart, contractEnd, status } = data;
  return (
    <div className="ca--table__row">
      {unableCheckBox && (
        <Checkbox
          className="header-checkbox--border"
          onChange={() => handleOnChange(data)}
          checked={selectAllClicked ? isAllChecked : data.isChecked}
          id="caTableRow"
          color="primary"
          icon={<IconCheckBoxEmpty stroke="#6F6F6F" />}
          checkedIcon={
            <IconCheckBoxCheck fill="#6F6F6F" stroke="#6F6F6F" opacity="0" />
          }
          disabled={false}
        />
      )}
      <Link
        className="ca-table-col-link"
        to={`${APP_ROOT_URL}/contractAdmin`}
        onClick={() => setFlag(true)}
      >
        <div className="ca--table__col ca-ct--col__column">
          <div className="ca--table__col--root">
            <span>{account.accountName}</span>
          </div>
        </div>
        <div className="ca--table__col ca-ct--col__column">
          <div className="ca--table__col--root">
            <span>{account.parentAccountDto.accountName}</span>
          </div>
        </div>
        <div className="ca--table__col ca-ct--col__column">
          <div className="ca--table__col--root">
            <span>{contractName}</span>
          </div>
        </div>
        <div className="ca--table__col ca-ct--col__column">
          <div className="ca--table__col--root">
            {account.lastModifiedDate !== null && (
              <span>
                {moment(account.lastModifiedDate).format('MMM DD YYYY')}
              </span>
            )}
            {account.lastModifiedDate === null && (
              <span className="blankDate">-</span>
            )}
          </div>
        </div>

        <div className="ca--table__col ca-ct--col__column">
          <div className="ca--table__col--root">
            <span>
              {getSelectedStatus(status, CA_ADD_CONTRACT_STATUS_OPTIONS)}
            </span>
          </div>
        </div>

        <div className="ca--table__col ca-ct--col__column">
          <div className="ca--table__col--root">
            <span>{moment(contractStart).format('MMM DD YYYY')}</span>
          </div>
        </div>

        <div className="ca--table__col ca-ct--col__column">
          <div className="ca--table__col--root">
            <span>{moment(contractEnd).format('MMM DD YYYY')}</span>
          </div>
        </div>
      </Link>
    </div>
  );
};

CATableRowItems.propTypes = {
  data: instanceOf(Object).isRequired,
  handleOnChange: func,
  selectAllClicked: bool,
  isAllChecked: bool,
  unableCheckBox: bool,
};

export default CATableRowItems;
